export enum AlarmType {
  OPERATING_HOURS = 'OPERATING_HOURS',
  OPERATING_HOURS_CONTRACT = 'OPERATING_HOURS_CONTRACT',
  TANK_FILL_LEVEL = 'TANK_FILL_LEVEL',
  FAULTS = 'FAULTS',
  TOTAL_COSTS = 'TOTAL_COSTS',
  DAMAGE_COSTS = 'DAMAGE_COSTS',
  REPAIR_COSTS = 'REPAIR_COSTS',
  GUARANTEE = 'GUARANTEE',
  FULL_SERVICE_CONTRACT_END = 'FULL_SERVICE_CONTRACT_END',
  LEASING_SERVICE_CONTRACT_END = 'LEASING_SERVICE_CONTRACT_END',
  GEOFENCE_VIOLATION = 'GEOFENCE_VIOLATION',
  GLOBAL_GEOFENCE_VIOLATION = 'GLOBAL_GEOFENCE_VIOLATION',
  TIMEFENCING = 'TIMEFENCING',
  TRANSPORT_TASK_CREATION = 'TRANSPORT_TASK_CREATION',
  TRANSPORT_TASK_RETURNED = 'TRANSPORT_TASK_RETURNED',
  NEW_DAMAGE_ADDED = 'NEW_DAMAGE_ADDED',
  INACTIVE_TELEMATICS_UNIT = 'INACTIVE_TELEMATICS_UNIT',
  BATTERY_VOLTAGE = 'BATTERY_VOLTAGE',
  DEF_TANK_LEVEL = 'DEF_TANK_LEVEL',
  TELEMATICS_UNIT_BATTERY_STATUS = 'TELEMATICS_UNIT_BATTERY_STATUS',
  THEFT_PROTECTION = 'THEFT_PROTECTION',
}

const ALARM_TYPE_SHAREABLE_EQUIPMENTS_SUPPORT_MAP: { [key in AlarmType]: boolean } = {
  [AlarmType.OPERATING_HOURS]: true,
  [AlarmType.TANK_FILL_LEVEL]: true,
  [AlarmType.GUARANTEE]: true,
  [AlarmType.GLOBAL_GEOFENCE_VIOLATION]: true,
  [AlarmType.TIMEFENCING]: true,
  [AlarmType.INACTIVE_TELEMATICS_UNIT]: true,
  [AlarmType.BATTERY_VOLTAGE]: true,
  [AlarmType.DEF_TANK_LEVEL]: true,
  [AlarmType.TELEMATICS_UNIT_BATTERY_STATUS]: true,
  [AlarmType.FAULTS]: false,
  [AlarmType.TOTAL_COSTS]: false,
  [AlarmType.DAMAGE_COSTS]: false,
  [AlarmType.REPAIR_COSTS]: false,
  [AlarmType.FULL_SERVICE_CONTRACT_END]: false,
  [AlarmType.LEASING_SERVICE_CONTRACT_END]: false,
  [AlarmType.TRANSPORT_TASK_CREATION]: false,
  [AlarmType.TRANSPORT_TASK_RETURNED]: false,
  [AlarmType.NEW_DAMAGE_ADDED]: false,
  [AlarmType.OPERATING_HOURS_CONTRACT]: false,
  [AlarmType.GEOFENCE_VIOLATION]: false,
  [AlarmType.THEFT_PROTECTION]: false,
};

export function isAlarmTypeSupportSharedEquipments(type: AlarmType): boolean {
  return ALARM_TYPE_SHAREABLE_EQUIPMENTS_SUPPORT_MAP[type] ?? false;
}
